import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { routes } from '@/app/routes';
import { Banner } from '../cookie-policy/components/banner';
import { PolicyContentView } from '../cookie-policy/components/policy-content-view';
import { POLICY_CONTENT } from '../cookie-policy/policy-config';
import { LoginForm } from './login-form-updated';
import { LoginPageBackground } from './login-styles';

export function LoginPage(props) {
  const history = useHistory();

  // checks the user's local storage to see if they have accepted the policy agreement.
  const policyStatus = localStorage.getItem('policyAgreement') === 'true';
  const [policyAccepted, setPolicyAccepted] = useState(policyStatus);
  const [policyPageActive, setPolicyPageActive] = useState(false);
  const [activePolicyContent, setActivePolicyContent] = useState(
    POLICY_CONTENT.PRIVACY
  );
  const possiblePwReset = props?.match?.params?.passwordReset
    ? JSON.parse(props.match.params.passwordReset)
    : null;

  if (policyPageActive) {
    return (
      <PolicyContentView
        setPolicyPageActive={setPolicyPageActive}
        activeContent={activePolicyContent}
        setActiveContent={setActivePolicyContent}
        showReturnToLoginLink={true}
      />
    );
  }

  return (
    <LoginPageBackground>
      <LoginForm possiblePwReset={possiblePwReset} history={history} />
      {!policyAccepted && (
        <Banner
          policyAccepted={policyAccepted}
          setActivePolicyContent={setActivePolicyContent}
          setPolicyAccepted={setPolicyAccepted}
          setPolicyPageActive={setPolicyPageActive}
        />
      )}
    </LoginPageBackground>
  );
}
